import React, { useEffect, useState } from 'react';
import { TextboxElementProps } from '../../../interfaces/formElements/TextboxElementProps'
import { TextboxElement } from 'models/forms/formElements/TextboxElement';

const TextboxElementComponent: React.FC<TextboxElementProps> = ({ element, isEditing, onUpdate, isDisabled }) => {

  const [textboxValue, setTextboxValue] = useState<string>(element.value);
  const [textboxName, setTextboxName] = useState<string>(element.name);
  const [textboxPlaceHolder, setTextboxPlaceHolder] = useState<string>(element.placeholder ?? "");
  const type = 'Models.Forms.FormElements.Textbox';

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedName = event.target.value;
    setTextboxName(updatedName);

    onUpdate({
      ...element, name: updatedName
    });
  };

  const handleTextboxInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const textboxinput = event.target.value;

    setTextboxValue(textboxinput);

    onUpdate({
      ...element, value: textboxinput
    });
  };

  const handlePlaceHolderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const placeholderUpdate = event.target.value;

    setTextboxPlaceHolder(placeholderUpdate);

    onUpdate({
      ...element, placeholder: placeholderUpdate
    });
  };


  if (isEditing) {
    return (
      <>
        <p className="mb-2 text-sm text-gray-700">Enter a label for this textbox.</p>
        <input
          type="text"
          value={element.value || textboxName}
          onChange={handleNameChange}
          className="block mb-2.5 px-2 py-2 border border-gray-300 rounded"
        />
      </>
    );

  }

  return (
    <div className="mb-2.5">
      <label htmlFor={element.id} className="block mb-1.5 font-medium text-gray-700">
        {element.name} {element.isRequired}
      </label>
      <input
        type="text"
        id={element.id}
        placeholder={element.placeholder || ''}
        value={element.value || textboxValue}
        onChange={handleTextboxInputChange}
        className="px-2 py-2 w-36 border border-gray-300 rounded"
        disabled={isDisabled ?? false}
      />
    </div>

  );
};

export default TextboxElementComponent;